import { render, staticRenderFns } from "./ElectronCardList.vue?vue&type=template&id=10a4460f&scoped=true"
import script from "./ElectronCardList.vue?vue&type=script&lang=js"
export * from "./ElectronCardList.vue?vue&type=script&lang=js"
import style0 from "./ElectronCardList.vue?vue&type=style&index=0&id=10a4460f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4460f",
  null
  
)

export default component.exports